module.exports = __webpack_public_path__ + "img/arrow_drop_up.52f283bb.svg";